import React, {Component} from "react";
import {Spinner} from "react-bootstrap";

class SubmissionMessage extends Component {

    render() {
        return (
            <div className={"confirmation"} style={{display: this.props.isVisible ? "block" : "none"}}>
                <h1>Vielen Dank</h1>
                <p>Übertrage Daten..</p>
                <Spinner animation={"border"} variant={"warning"} size={"large"}/>
            </div>
        );
    }
}

export default SubmissionMessage;
